<template>
  <div>
    <v-dialog
      v-model="dialogProps.visibilidade"
      :persistent="dialogProps.dialogAceitar"
      max-width="600px"
    >
      <v-card class="pa-5">
        <v-card-title>
          <v-row class="d-flex flex-column text-lg-center">
            <h4 class="headline primary--text text-no-wrap pb-8">
              Termo de Responsabilidade
            </h4>
          </v-row>
        </v-card-title>
        <v-card-text>
          <p class="text-justify">
            Declaro, para os devidos fins, a legitimidade das informações que
            serão prestadas e me comprometo a apresentar os certificados,
            diplomas e declarações comprovantes de sua veracidade em todas as
            ocasiões em que for solicitado.
          </p>
          <v-checkbox
            v-model="usuario.perfil.aceitouTermoResponsabilidade"
            :label="termoCiencia"
            class="text-justify"
            color="secondary"
            :readonly="
              usuario.perfil.aceitouTermoResponsabilidade &&
                dialogProps.dialogVisualizar
            "
          />
          <v-checkbox
            v-model="usuario.perfil.aceitouTermoUsoLgpd"
            class="text-justify"
            color="secondary"
            :readonly="
              usuario.perfil.aceitouTermoUsoLgpd &&
                dialogProps.dialogVisualizar
            "
          >
            <template v-slot:label>
              <p class="mt-4">
                Declaro que li e concordo com o
                <v-tooltip top>
                  <template v-slot:activator="{ on: onTooltip }">
                    <a
                      href="#"
                      class="secondary--text font-weight-regular"
                      aria-label="acesse o termo de uso de dados do desenvolva"
                      v-on="{ ...onTooltip }"
                      @click.stop="abrirTermoUso"
                    >
                      termo de uso de dados do sistema.
                    </a>
                  </template>
                  <span>Clique visualizar o termo de uso de dados</span>
                </v-tooltip>
              </p>
            </template>
          </v-checkbox>
          <p
            v-if="dialogProps.dialogVisualizar"
            class="text-end primary--text body-2"
          >
            Ciência dada em
            {{ usuario.perfil.dataAceitouTermoResponsabilidade | date }}.
          </p>
        </v-card-text>
        <v-card-actions>
          <v-row class="justify-end ma-1">
            <v-btn
              v-if="dialogProps.dialogAceitar"
              :disabled="!usuario.perfil.aceitouTermoResponsabilidade || !usuario.perfil.aceitouTermoUsoLgpd"
              class="mr-2"
              color="primary"
              @click="aceitarTermos()"
            >
              Confirmar
            </v-btn>
            <v-btn
              color="primary"
              outlined
              @click="cancelar"
            >
              {{ nomeBtn() }}
            </v-btn>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { RepositoryFactory } from '@/repositories/RepositoryFactory';
import Data from '@/modules/data';

const perfilRepository = RepositoryFactory.get('perfil');

export default {
  name: 'TermoResponsabilidade',

  props: {
    dialogProps: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      breadcrumbItems: [
        {
          position: 1,
          text: 'Início',
          disabled: false,
          href: '/inicio',
        },
        {
          position: 2,
          text: 'Dashboard Perfil',
          disabled: false,
          href: '/perfil',
        },
        { position: 3, text: 'Termo de Responsabilidade', disabled: true },
      ],
      urlTermoUso: 'https://desenvolva.ufc.br/wp-content/uploads/2022/10/termo-de-uso-de-dados-desenvolva.pdf',
    };
  },

  computed: {
    ...mapState({
      usuario: (state) => state.auth.usuario,
    }),
    termoCiencia() {
      return (
        'Estou ciente que a declaração falsa infringe o Código de Ética Profissional do Serviço '
        + 'Público Civil, como também o artigo 299 do Código Penal Brasileiro e que responderei civil, penal '
        + 'e administrativamente caso ela ocorra.'
      );
    },
  },

  methods: {
    ...mapActions('app', ['setBreadcrumbs']),
    nomeBtn() {
      if (this.dialogProps.dialogAceitar) {
        return 'Voltar';
      }
      return 'Fechar';
    },
    abrirTermoUso() {
      window.open(this.urlTermoUso, '_blank');
      window.focus();
    },
    aceitarTermos() {
      this.usuario.perfil.dataAceitouTermoResponsabilidade = Data.get('YYYY-MM-DD');
      perfilRepository.update(this.usuario.perfil).then((res) => {
        this.usuario.perfil = res.data;
        this.$store.dispatch('app/success', { response: res, message: 'Termos aceitos com sucesso!' });
        this.dialogProps.visibilidade = !this.usuario.perfil.aceitouTermoResponsabilidade;
      });
    },
    cancelar() {
      if (this.dialogProps.dialogAceitar) {
        this.usuario.perfil.aceitouTermoResponsabilidade = false;
        this.usuario.perfil.aceitouTermoUsoLgpd = false;
        this.$router.push('/perfil');
      } else {
        this.dialogProps.visibilidade = false;
      }
    },
  },
};
</script>
